import React from 'react';
import { motion } from 'framer-motion';
import posthog from 'posthog-js';
import { ProtectedImage } from './ProtectedImage';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-93">
      {/* Background Image */}
      <motion.div initial={{
      scale: 1.05
    }} animate={{
      scale: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute inset-0" data-id="element-94">
        <div className="absolute inset-0 bg-black/45 z-10" data-id="element-95" />
        <ProtectedImage src="https://cdn.magicpatterns.com/uploads/1aaE322htboioX8b13u4Se/image.png" alt="Dubai skyline with converging highways" className="w-full h-full object-cover object-center" wrapperClassName="w-full h-full" data-id="element-96" />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-6" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.5
      }} data-id="element-98">
          <h1 className="text-white font-serif text-5xl md:text-7xl lg:text-8xl tracking-wider mb-6" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.5)'
        }} data-id="element-99">
            ALEJANDRO
            <br data-id="element-100" />
            NORIEGA
          </h1>
          <p className="text-white/90 font-sans text-[10px] md:text-xs tracking-[0.3em] uppercase mb-12" style={{
          textShadow: '0 1px 10px rgba(0,0,0,0.5)'
        }} data-id="element-101">
            Street and Fine Art Photography
          </p>
          <a href="#collections" onClick={() => posthog.capture('hero_cta_clicked', {
          cta_text: 'View Collections'
        })} className="inline-block border border-white/60 text-white px-8 py-3 text-[10px] md:text-xs font-medium tracking-[0.2em] uppercase transition-all hover:bg-white hover:text-charcoal hover:border-white" data-id="element-102">
            View Collections
          </a>
        </motion.div>
      </div>
    </section>;
}